// import { Button } from "../components/ui/button";
import { Sun } from "lucide-react";
import { Button } from "./ui/button";

const Header = () => {
  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 w-full bg-background/95 backdrop-blur-sm border-b border-border z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="bg-gradient-solar p-2 rounded-lg">
            <Sun className="h-6 w-6 text-primary-foreground" />
          </div>
          <h1 className="text-2xl font-bold bg-gradient-solar bg-clip-text text-transparent">
            PASAT COMPANY
          </h1>
        </div>
        
        <nav className="hidden md:flex items-center gap-6">
          <button 
            onClick={() => scrollToSection('solar-panels')}
            className="text-foreground hover:text-primary transition-colors"
          >
            Solar Panels
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className="text-foreground hover:text-primary transition-colors"
          >
            About Us
          </button>
          <button 
            onClick={() => scrollToSection('partners')}
            className="text-foreground hover:text-primary transition-colors"
          >
            Partners
          </button>
          <button 
            onClick={() => scrollToSection('reviews')}
            className="text-foreground hover:text-primary transition-colors"
          >
            Reviews
          </button>
          <Button 
            variant="solar"
            onClick={() => scrollToSection('contact')}
          >
            Get Quote
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;